"use client";

import React from "react";
import { IoMdSunny } from "react-icons/io";
import { IoMoon } from "react-icons/io5";
import { useTheme } from "@/contexts/ThemeContext";

const ThemeSwitcher = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="flex items-center text-lg relative">
      <div
        className={`w-1/2 lg:w-10 h-7.5 grid place-items-center rounded-2xl transition-all duration-300 absolute bg-bg2 ${
          theme === "dark" ? "left-1/2 lg:left-10" : "left-0"
        }`}
      ></div>

      <button
        onClick={() => setTheme("light")}
        className={`w-1/2 lg:w-10 h-7.5 grid place-items-center rounded-2xl cursor-pointer transition-all relative ${
          theme === "light" ? "bg-bg2" : ""
        }`}
        title="Light Mode"
      >
        <IoMdSunny className="text-text1" />
      </button>
      <button
        onClick={() => setTheme("dark")}
        className={`w-1/2 lg:w-10 h-7.5 grid place-items-center rounded-2xl cursor-pointer transition-all relative ${
          theme === "dark" ? "bg-bg2" : ""
        }`}
        title="Dark Mode"
      >
        <IoMoon className="text-text1 text-sm" />
      </button>
    </div>
  );
};

export default ThemeSwitcher;
